import React, { useEffect, useState } from 'react';
import { CalMeetingForm } from '../exo/cal/types/meeting/CalMeetingForm';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../api/api';
import findDifferences from '../exo/findDifferencesInDataCollection';
import { Box, Button, Typography } from '@mui/material';
import CalendarSelect from '../exo/cal/types/CalendarSelect';
import useFetch from '../../api/useFetch';

export const NewMeeting = ({
  startData,
  onCreate,
  onUpdate,
  onDelete,
  onClose,
  onFeedback,
  debug,
  openParticipantsBlockTimes,
  setOpenParticipantsBlockTimes,
}) => {
  const { t } = useTranslation();
  const cookies = new Cookies();
  const userId = cookies.get('userId');
  const config = useConfig();

  const { apiData } = useFetch(`calendar/own?noEvents=true`);

  useEffect(() => {}, [apiData]);

  const [isValid, setIsValid] = useState(false);

  const [dataCollection, setDataCollection] = useState({});
  const [selectedCalendar, setSelectedCalendar] = useState(null);

  function handleChange(newData) {
    setDataCollection({ ...dataCollection, ...newData });
  }

  // startData functions
  function meetingDefaultData() {
    const startDateTime = moment().toISOString();
    const endDateTime = moment().toISOString();

    // Get the current time and round it up to the next 30-minute mark
    const now = moment();
    const roundedStart = now
      .clone()
      .add(30 - (now.minute() % 30), 'minutes')
      .startOf('minute');

    // Set the endDateTime to 30 minutes after the rounded start time
    const roundedEnd = roundedStart.clone().add(30, 'minutes');

    return {
      startTime: roundedStart.toISOString(),
      startDate: startDateTime,
      endTime: roundedEnd.toISOString(),
      endDate: endDateTime,
      wholeDay: '0',
      meetingIsConfirmed: '0',
      label: t('New Meeting'),
      type: 'meeting',
      blockTime: '0',
      owner: {
        id: userId,
      },
    };
  }
  const defaultData = meetingDefaultData();
  useEffect(() => {
    if (startData) return setDataCollection({ ...defaultData, ...startData });

    setDataCollection(defaultData);
  }, [startData]);

  // submit
  function handleSubmit(sendEmails) {
    const startMoment = moment(dataCollection.startTime);
    const endMoment = moment(dataCollection.endTime);

    const startTime = startMoment.format('HH:mm');
    const startDate = moment(dataCollection.startDate).format('YYYY-MM-DD');
    const startMomentMerged = moment(
      `${startDate} ${startTime}`,
      'YYYY-MM-DD HH:mm'
    );

    const endTime = endMoment.format('HH:mm');
    const endDate = moment(dataCollection.endDate).format('YYYY-MM-DD');
    const endMomentMerged = moment(`${endDate} ${endTime}`, 'YYYY-MM-DD HH:mm');

    const reqData = {
      ...dataCollection,
      startDateTime: startMomentMerged.toISOString(),
      endDateTime: endMomentMerged.toISOString(),
      sendEmails: Boolean(sendEmails),
      calendarId: selectedCalendar.id,
    };
    DBRequest({
      config,
      path: dataCollection.id
        ? `calendar-events/${dataCollection.id}`
        : 'calendar-events',
      method: dataCollection.id
        ? API_PATCH(findDifferences(startData, reqData))
        : API_POST(reqData),
      onFeedback,
      onResponse: (res) => {
        dataCollection.id
          ? onUpdate({
              ...res.data,
              calendar: selectedCalendar,
              color: selectedCalendar.color,
            })
          : onCreate({
              ...res.data,
              calendar: selectedCalendar,
              color: selectedCalendar.color,
            });
        setDataCollection({});
      },
    });
    onClose();
  }

  // calendar change & meeting move logic
  function handleCalendarChange(newCal) {
    if (dataCollection.id) handleMoveMeeting(dataCollection, newCal);
    setSelectedCalendar(newCal);
  }

  function handleMoveMeeting(meeting, newCal) {
    DBRequest({
      config,
      path: `calendar-events/${meeting.id}/move`,
      method: API_PATCH({
        fromCalendarId: meeting.calendar?.id,
        toCalendarId: newCal.id,
      }),
      onFeedback,
      onError: () => setSelectedCalendar(meeting.calendar),
    });
  }

  return (
    <Box className="flex flex-col h-full w-full justify-between gap-2  ">
      <Box className="h-full w-full flex flex-col overflow-y-auto px-3">
        {debug && (
          <Button
            onClick={() => console.log(dataCollection)}
            variant="contained"
            color="warning"
            sx={{ position: 'absolute' }}
            className="top-1 left-1"
          >
            debug
          </Button>
        )}
        <Typography variant="h3" textAlign="center">
          {t('New Meeting')}
        </Typography>
        <Box className="py-2">
          <CalendarSelect
            calendars={apiData?.data}
            selectedCal={selectedCalendar}
            onSelect={handleCalendarChange}
            size="large"
          />
        </Box>

        <CalMeetingForm
          dataCollection={dataCollection}
          onValidationChange={setIsValid}
          onChange={handleChange}
          openBlock={openParticipantsBlockTimes}
          setOpenBlock={setOpenParticipantsBlockTimes}
        />
      </Box>
      <Box className="w-full flex justify-between pb-2 px-3">
        <Button variant="outlined" color="error" onClick={onClose}>
          {t('Cancel')}
        </Button>
        <Button variant="contained" color="success" onClick={handleSubmit}>
          {t('Save')}
        </Button>
      </Box>
    </Box>
  );
};
